import { render, staticRenderFns } from "./TwoCol5050.vue?vue&type=template&id=49f0124a&"
import script from "./TwoCol5050.vue?vue&type=script&lang=js&"
export * from "./TwoCol5050.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports